import { storage } from 'BASE/common/util/util.storage';
import {Logout as _Logout} from '#BASE/common/login/login.util';
export *  from '#BASE/common/login/login.util';

export const Logout = function () {
    _Logout();
    storage.local.remove(storage.keys.LOGIN_ANNOUCEMENTS);
    storage.local.remove(storage.keys.READ_ANNOUNCEMENT);
    storage.local.remove(storage.keys.LOGIN_MARQUEE);
    storage.local.remove(storage.keys.BANKCARD_DISABLE_ANNOUNCEMENT_CONFIRMED);
};